module.exports = __webpack_public_path__ + "c48cbb7576e97790e7acd5b78f4c294c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/columbia_university_2023_chart.png
// module id = 1657
// module chunks = 0